// Module
var code = "<div class=\"paginatedTabs\"></div>\n";
// Exports
module.exports = code;